export default __webpack_public_path__ + "static/media/logo_chiken.9c4ec78d.png";